/**
 * @author Martin Albarracin
 * @file routes.js
 * @description Video calls routes
 */

// Pages
import VideoCallsFrame from '@nephro/pages/VideoCallsFrame';

const pathStart = '/main/videocalls-frame';
const routes = [
  {
    path: `${pathStart}/`,
    isProtected: true,
    component: VideoCallsFrame,
    exact: true
  },
  { redirect: true, to: `${pathStart}/` }
];

export default routes;
